var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "search_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M9.52 15.615c-1.708 0-3.155-.592-4.34-1.777-1.184-1.184-1.776-2.63-1.776-4.338 0-1.708.592-3.154 1.777-4.338 1.184-1.185 2.63-1.777 4.338-1.777 1.708 0 3.154.592 4.339 1.777 1.184 1.184 1.777 2.63 1.777 4.338 0 .714-.12 1.396-.36 2.046a5.72 5.72 0 0 1-.96 1.696l5.754 5.754c.139.139.21.313.213.522a.707.707 0 0 1-.213.532.718.718 0 0 1-.527.217.718.718 0 0 1-.527-.217l-5.753-5.754c-.5.413-1.075.736-1.725.97-.65.233-1.323.35-2.018.35Zm0-1.5c1.288 0 2.38-.447 3.273-1.341.895-.894 1.342-1.985 1.342-3.274 0-1.288-.447-2.38-1.342-3.274-.894-.894-1.985-1.341-3.274-1.341-1.288 0-2.38.447-3.274 1.34-.894.895-1.341 1.987-1.341 3.275 0 1.289.447 2.38 1.341 3.274.894.894 1.986 1.341 3.274 1.341Z",
    fill: "currentColor"
  }))));
};
export default SvgSearch;